import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { publicTableService } from '../services/api';
import { useCart } from '../contexts/CartContext';
import PublicMenu from './PublicMenu';

/**
 * Punto d'ingresso quando si scansiona il QR di un tavolo.
 * Apre il tavolo, salva la sessione tavolo nel CartContext e mostra
 * il menu pubblico identico, con la possibilità di ordinare al tavolo.
 */
export default function TableEntry() {
  const { uuid } = useParams<{ uuid: string }>();
  const { setTableSession } = useCart();
  const [state, setState] = useState<'loading' | 'ready' | 'error'>('loading');

  useEffect(() => {
    const init = async () => {
      if (!uuid) { setState('error'); return; }
      try {
        const openRes = await publicTableService.openTable(uuid);
        const infoRes = await publicTableService.getTable(uuid);
        if (!openRes.success && !infoRes.success) { setState('error'); return; }
        const t = infoRes.data?.table;
        const label = t ? `${t.room_name} — Tavolo ${t.name}` : 'Tavolo';
        setTableSession(uuid, label);
        setState('ready');
      } catch {
        setState('error');
      }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuid]);

  if (state === 'loading') {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6b7280', fontFamily: 'system-ui' }}>
        Apertura tavolo…
      </div>
    );
  }

  if (state === 'error') {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8, padding: 24, textAlign: 'center', fontFamily: 'system-ui' }}>
        <div style={{ fontSize: 40 }}>❓</div>
        <div style={{ fontWeight: 700, color: '#1f2937' }}>Tavolo non disponibile</div>
        <div style={{ color: '#6b7280', fontSize: 14 }}>Il QR non è valido o il tavolo non è attivo.<br />Chiedi assistenza al personale.</div>
      </div>
    );
  }

  // Menu pubblico identico, con sessione tavolo attiva
  return <PublicMenu />;
}
